<template>
  <Header/>
  <div class="section">
    <div class="customer-top" id="customer-top">
      <div class="content-sm">
        <div class="d-flex columns">
          <div class="customer-avatar-container">
            <div v-if="avatar_url" :key="avatar_url" class="customer-avatar col-num" v-bind:style="{ 'background': 'url(' + avatar_url + ')' }"></div>
            <div v-else class="col-num " :class="'col-num--'+customer.tier">
              {{ customer.tier }}
            </div>
              <img src="../assets/images/plus.svg" v-if="isMobile()" @click="onPickFileMobile" class="customer-add-photo"/>
              <div v-else>
                <img src="../assets/images/plus.svg" @click="onPickFile" class="customer-add-photo"/>
                <input
                  type="file"
                  style="display: none"
                  ref="fileInput"
                  accept="image/*"
                  @change="onFilePicked"/>
              </div>
          </div>
          <div class="customer-top__info" v-if="customer.id">
            <h1>{{ customer.first_name }} {{ customer.last_name }}</h1>
            <CustomerTypesTable
              v-if="customer.types.length > 0"
              :customerTypes="customer.types"
              :customerSubTypes="customer.sub_types"
            />
            <div v-if="customer.tier">
              Tier {{ customer.tier }}
            </div>
            <div v-if="customer.instagram_handle">
              {{ instagramFollowersCount }} Followers
            </div>
            <div>Updated: {{ helpers.formatDate(customer.updated_at) }}</div>
          </div>
        </div>
        <div class="customer-top__buttons d-flex" v-if="customer.id">
          <button class="btn btn-tab" @click="openEmailDialogBox">
            Send Email
          </button>
          <button class="btn btn-tab" @click="openTextDialogBox">
            Send Text
          </button>
          <router-link :to="{name: 'Create Order', params: {userid: customer.id}}" class="btn btn--primary btn-tab">New Order
          </router-link>
        </div>
      </div>
    </div>
    <div class="tabs">
      <simplebar>
        <div class="content-sm">
          <ul class="tabs-nav">
            <li v-if="customer.instagram_handle">
              <button data-tab="tab-instagram" class="btn tab-toggle" :class="{ active: tab === 'instagram' }"
                      @click="tab = 'instagram'">
                Instagram
              </button>
            </li>
            <li>
              <button data-tab="tab-contact" class="btn tab-toggle" :class="{ active: tab === 'contact' }"
                      @click="tab = 'contact'">
                Contact
              </button>
            </li>
            <li>
              <button data-tab="tab-sizing" class="btn tab-toggle" :class="{ active: tab === 'sizing' }"
                      @click="tab = 'sizing'">
                Sizing
              </button>
            </li>
            <li>
              <button data-tab="tab-orders" class="btn tab-toggle" :class="{ active: tab === 'orders' }"
                      @click="tab = 'orders'">
                Orders
              </button>
            </li>
            <li>
              <button data-tab="tab-sizing" class="btn tab-toggle" :class="{ active: tab === 'notes' }"
                      @click="tab = 'notes'">
                Notes
              </button>
            </li>
          </ul>
        </div>
      </simplebar>
    </div>
    <SearchCustomerOrders v-if="tab == 'orders'" @update-orders="searchForOrders"/>
    <div class="container content">
      <div class="panel panel-collapse" v-if="tab === 'instagram'">
        <div class="panel__content">
          <div class="panel__heading">
            <h2>Instagram</h2>
          </div>
          <Instagram v-if="customer.instagram_handle" @load="updateInstagramFollowersCount" />
        </div>
      </div>
      <div class="panel panel-collapse" id="tab-contact" v-if="tab === 'contact'">
        <div class="panel__content">
          <div class="panel__heading">
            <h2>Contact Information</h2>
          </div>
          <CustomerContact
            :tier="customer.tier"
            :first-name="customer.first_name"
            :last-name="customer.last_name"
            :customer-nickname="customer.nickname"
            :instagram-handle="customer.instagram_handle"
            :email="customer.email"
            :phone="customer.phone"
            :notification-preference="customer.notification_preference"
            :customer-types="customer.types.map((type) => type.id)"
            :customer-sub-types="customer.sub_types.map((subType) => subType)"
            :customer-addresses="customer.customer_addresses"
            :customer-id="customer.id"
            :creating-customer="false"
            :error-message="errorMessage"

            button-text="Update"
            :show-tier="true"
            :show-notification="true"
            @contactFormSubmitted="updateCustomerContact"
            @addressFormSubmitted="updateCustomerAddress"
          />
        </div>
      </div>
      <div class="panel panel-collapse" id="tab-sizing" v-if="tab === 'sizing'">
        <div class="panel__content">
          <div class="panel__heading">
            <h2>Sizing</h2>
          </div>
          <CustomerSizing
            :tops="customer.tops"
            :bottoms="customer.bottoms"
            :fitted-hats="customer.fitted_hats"
            :footwear="customer.footwear"
            :accessories="customer.accessories"
            :tops-confirmed="customer.tops_sizes_confirmed"
            :bottoms-confirmed="customer.bottoms_sizes_confirmed"
            :headwear-confirmed="customer.headwear_sizes_confirmed"
            :footwear-confirmed="customer.footwear_sizes_confirmed"
            :accessories-confirmed="customer.accessories_sizes_confirmed"

            button-text="Update"
            @sizingFormSubmitted="updateCustomerSizing"
          />
        </div>
      </div>
      <div class="panel panel-collapse" id="tab-orders" v-if="tab === 'orders'">
        <div class="panel__content">
          <div class="panel__heading">
            <h2>Orders</h2>
          </div>
          <CustomerOrders
            :customerId="customer.id?.toString()"
            :orders="customer_orders"
            :key="customer_orders_key"
          />
        </div>
      </div>
      <div class="panel panel-collapse" id="tab-notes" v-if="tab === 'notes'">
        <div class="panel__content">
          <div class="panel__heading">
            <h2>Notes</h2>
          </div>
          <CustomerNotes
            :customer_notes="customer_notes"
            :customer_id="$route.params.customer_id?.toString()"

            button-text="Update"
            @customerNoteSubmitted="updateCustomerNotes"
          />
        </div>
      </div>
    </div>
    <CustomerEmail v-if="openEmailDialog" ref="dialog"
                   :name="customer.first_name"
                   :email="customer.email"
                   :customerId="customer.id"
                   class="show"></CustomerEmail>
    <CustomerText v-if="openTextDialog" ref="dialogText"
                   :phone="customer.phone"
                   :name="customer.first_name"
                   :customerId="customer.id"
                   class="show"></CustomerText>
    <CustomerAvatarUpload v-if="showAvatarUpload"
      @showAvatarUpload="onPickFileMobile"
      @updateAvatar="updateAvatar"
      :customerId="customer.id"
      :customerAvatar="customer.avatar.url"
    />
  </div>
</template>

<script>
import api from '../api'

import simplebar from '../components/simplebar.vue';
import 'simplebar/dist/simplebar.min.css';
import Header from '../components/Header.vue';
import Instagram from '../components/Instagram.vue'
import CustomerContact from '../components/CustomerContact.vue';
import CustomerSizing from '../components/CustomerSizing.vue';
import CustomerOrders from '../components/CustomerOrders.vue';
import CustomerNotes from '../components/CustomerNotes.vue';
import CustomerEmail from '../components/CustomerEmail.vue';
import CustomerText from '../components/CustomerText.vue';
import CustomerTypesTable from '../components/CustomerTypesTable.vue';
import CustomerAvatarUpload from '../components/CustomerAvatarUpload.vue';
import SearchCustomerOrders from '../components/SearchCustomerOrders.vue';

export default {
  name: 'Customer',
  components: {
    Header, simplebar, Instagram, CustomerContact, CustomerSizing, CustomerOrders, CustomerNotes, CustomerEmail, CustomerText, SearchCustomerOrders, CustomerAvatarUpload, CustomerTypesTable
  },
  methods: {
    onPickFileMobile() {
      this.showAvatarUpload = !this.showAvatarUpload
    },
    onPickFile() {
      this.$refs.fileInput.click()
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    updateAvatar(customer) {
      this.showAvatarUpload = false
      this.customer = customer
      this.avatar_url = customer.avatar.url
    },
    onFilePicked (event) {
      const files = event.target.files
      this.avatar = files[0]
      let params = { avatar: this.avatar }
      api.updateCustomer(this.customer.id, params).then(customer => {
        this.customer = customer
        this.updateAvatar(this.customer)
      }).catch(errors => {
        console.error(errors);
      })
    },
    searchForOrders(searchTerm) {
      this.getCustomerOrders(searchTerm)
    },
    updateCustomerAddress(customerId) {
      api.getCustomer(customerId).then(customer => {
        this.customer = customer;
        this.tab = 'contact';
      }).catch(error => {
        console.log(error);
      });
    },
    updateCustomerContact(contactAttributes, form) {
      const submitButton = form.elements.submit;
      this.errorMessage = null;
      submitButton.disabled = true;

      api.updateCustomer(this.customer.id, contactAttributes).then(customer => {
        this.customer = customer;
        this.message = "Settings saved successfully!"
        // alert(this.message)
      }).catch(error => {
        if (error.data) {
          for (let key in error.data) {
            if (error.data[key]) {
              const capitalizedKey = key.charAt(0).toUpperCase() + key.slice(1);
              this.errorMessage = `${capitalizedKey} ${error.data[key][0]}`;
            }
          }
        } else {
          console.error(error);
        }
      }).finally(() => {
        submitButton.disabled = false
      });
    },
    updateCustomerNotes() {
      api.getCustomerNotes(this.customer.id).then(customer_notes => {
        this.customer_notes = customer_notes;
      }).catch(error => {
        console.log(error);
      });
    },
    updateCustomerSizing(sizingAttributes, form) {
      const submitButton = form.elements.submit;
      submitButton.disabled = true;
      api.updateCustomer(this.customer.id, sizingAttributes).then(customer => {
        this.customer = customer;
        this.message = "Settings saved successfully!"
        // alert(this.message)
      }).catch(errors => {
        console.error(errors);
      }).finally(() => {
        submitButton.disabled = false
      });
    },
    openEmailDialogBox() {
      this.openEmailDialog = true;
      this.$refs.dialog?.$el.classList.add('show');
    },
    openTextDialogBox() {
      this.openTextDialog = true;
      this.$refs.dialogText?.$el.classList.add('show');
    },
    updateInstagramFollowersCount() {
      this.instagramFollowersCount = this.customer.instagram_followers
    },
    getCustomerOrders(query){
      let q = '';
      if(query !== undefined) {
        q += `?query=${query}`
      }
      this.axios.get(`/v1/customers/${this.$route.params.customer_id}/customer_orders.json` + q)
        .then(response => {
          if (typeof response.data.records !== 'undefined') {
            this.customer_orders = response.data.records;
            this.customer_orders_key += 1;
          }
          this.requestCustomerCompleted = true;
        })
        .catch((error) => {
          console.log(error)
        });
    },
  },
  data() {
    return {
      tab: 'instagram',
      customer: {},
      avatar: null,
      customer_notes: [],
      customer_orders: [],
      instagramFollowersCount: 0,
      openEmailDialog: false,
      openTextDialog: false,
      customer_orders_key: 0,
      showAvatarUpload: false,
      avatar_url: null,
      errorMessage: null,
    }
  },
  mounted() {
    const customerId = this.$route.params.customer_id;
    api.getCustomerOrders(customerId, '?sort_by=created_at&sort_direction=desc').then(customer_orders => {
      this.customer_orders = customer_orders;
    }).catch(error => {
      console.log(error);
    });
    api.getCustomer(customerId).then(customer => {
      this.customer = customer;
      this.avatar_url = customer.avatar.url
      if (this.customer.instagram_handle == null) {
        this.tab = 'contact';
      }
    }).catch(error => {
      console.log(error);
    });
    api.getCustomerNotes(customerId).then(customer_notes => {
      this.customer_notes = customer_notes;
    }).catch(error => {
      console.log(error);
    });
  }
}
</script>
<style scoped>
  .customer-avatar-container {
    position: relative;
  }
  .col-num {
    position: relative;
  }
  .col-num--1 {
    background-color: #A5C3D0;
  }

  .col-num--2 {
    background-color: #F4C474;
  }

  .col-num--3 {
    background-color: #DF9B85;
  }

  .customer-avatar {
    background-position: center center !important;
    background-size: 120% auto !important;
    background-repeat: no-repeat !important;
  }

  .customer-add-photo {
    position: absolute;
    width: 18px;
    height: 18px;
    top: 30px;
    right: 0px;
    cursor: pointer;
  }

  #tab-orders {
    margin-top: 65px;
  }

  .tab-toggle {
    color: black;
  }

  .btn-tab {
    color: black;
    background-color: #efefef;
  }

  .btn--primary {
    background-color: #efefef;
  }
</style>
